<template>
  <div class="app-root">
    <div v-if="routeLoading" class="route-progress" aria-hidden="true"></div>
    <router-view />
  </div>
</template>

<script>
import { routeLoading } from './router/loading';

export default {
  name: 'App',
  setup() {
    return { routeLoading };
  },
};
</script>

<style>
@import './styles/design-tokens.css';

.app-root {
  min-height: 100vh;
}

.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 2000;
  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
  animation: route-progress-pulse 0.9s ease-in-out infinite;
}

@keyframes route-progress-pulse {
  0% { opacity: 0.55; }
  50% { opacity: 1; }
  100% { opacity: 0.55; }
}

@media (prefers-reduced-motion: reduce) {
  .route-progress {
    animation: none;
    opacity: 0.85;
  }
}
</style>
